export default __webpack_public_path__ + "static/media/topola.a3ffa9a5.jpg";